import { Brand, createBranded } from '@deltasierra/type-utilities';
import { Auditable, HasId, HasTimestamps, ParanoidAuditable } from '../common/model/traits';
import { LocationId } from '../location/Location';
import { UserId } from '../user/User';

export type GeneralPurposeTokenId = Brand<number, 'GeneralPurposeTokenId'>;
export const GeneralPurposeTokenId = createBranded<GeneralPurposeTokenId>();

export enum TokenType {
    LoginToken = 'login',
    InviteToken = 'invite',
}

export interface GeneralPurposeToken<T>
    extends HasId<GeneralPurposeTokenId>,
        HasTimestamps,
        Auditable,
        ParanoidAuditable {
    type: TokenType;
    token: string;
    data: T;
    expiresAt: Date;
}

export type LoginTokenData = { username: string; locationId: LocationId | null };
export type LoginToken = GeneralPurposeToken<LoginTokenData>;

export type InviteTokenData = { userId: UserId };
export type InviteToken = GeneralPurposeToken<InviteTokenData>;
